import { render, staticRenderFns } from "./BrickOctagonBase.vue?vue&type=template&id=11d97a09&scoped=true&"
import script from "./BrickOctagonBase.vue?vue&type=script&lang=js&"
export * from "./BrickOctagonBase.vue?vue&type=script&lang=js&"
import style0 from "../Style/brick-octagon-base.scss?vue&type=style&index=0&id=11d97a09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d97a09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d97a09')) {
      api.createRecord('11d97a09', component.options)
    } else {
      api.reload('11d97a09', component.options)
    }
    module.hot.accept("./BrickOctagonBase.vue?vue&type=template&id=11d97a09&scoped=true&", function () {
      api.rerender('11d97a09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/BrickOctagonBase.vue"
export default component.exports